'use client';

/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import cx from 'clsx';
import { useTranslations } from 'next-intl';

import Link from '@/components/Link';
import ListItem from '@/components/ListItem';
import { HowWeBuildProduct } from '@/config/how-we-build-products.config';
import colors from '@/styles/themes/colors';
import { useGlowEffect } from '@/utils/hooks/useGlowEffect';

import styles from './HowWeBuildProductCard.module.scss';

const HowWeBuildProductCard = ({
  image,
  title,
  link,
  linkText,
  description,
  features,
  color,
  bulletColor,
}: Omit<HowWeBuildProduct, 'key'>) => {
  const { ref, onMouseMove, onMouseLeave, style } = useGlowEffect({ color });
  const t = useTranslations('home');

  return (
    <Card classes={{ root: styles.root }} className={styles.container}>
      <CardMedia component="img" image={image.src} alt={image.alt} />
      <CardContent
        ref={ref}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        className={styles.content}
        style={style}
      >
        <Link href={link as '/'} text={t(linkText as any)} />
        <Typography component="h3" variant="h5">
          {t(title as any)}
        </Typography>
        <Typography variant="body1" color={colors.graytone200}>
          {t(description as any)}
        </Typography>
        <Box className={styles.listWrapper}>
          {features.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <ListItem key={index} text={t(item as any)} variant={bulletColor} />
          ))}
        </Box>
        <Box className={cx(styles.ellipse, styles[bulletColor])} />
      </CardContent>
    </Card>
  );
};

export default HowWeBuildProductCard;
